<template>
  <div>
    <menuBar></menuBar>
    <div class="cust-container tuition-and-fees">
      <img src="@/assets/images/tuitionandFees/banner.jpg" class="banner" />

      <div class="header-container">
        <h1>学杂费</h1>
        <h4>
          在每个级别，SCAD 学杂费涵盖了 SCAD
          教育在课堂、社交活动中的资源，以及与您选择的相关职业领域与行业领导者合作的成本。
        </h4>
      </div>

      <div class="nav-container">
        <div class="nav-list">
          <div class="nav-item">
            <a class="active" href="/T-F-Under-Grad-2026">本科生</a>
            <a href="/T-F-Grad-2026">研究生</a>
          </div>

          <div class="nav-item">
            <a class="active" href="/T-F-Under-Grad-2026">2026-27</a>
            <a href="/T-F-Under-Grad-2027">2027-28</a>
            <!--            <a class="" href="/T-F-Under-Grad-2023">2022-23</a>-->
            <!--<a href="/T-F-Under-Grad-2022">2021-22</a>-->
            <a
              href="https://scad-minisite.oss-cn-beijing.aliyuncs.com/pdf/202608/2026-27_SCN_Meal_Plans.pdf"
              class="active"
              target="_blank"
              style="
                color: #387cb0;
                background: white;
                border: 1.5px solid #387cb0;
              "
              >膳食套餐</a
            >
          </div>

          <!--          <div class="nav-item" v-if="mealPlans"></div>-->
        </div>
      </div>

      <div class="tuitionand-fees-container section-admission-tuition-and-fees">
        <div id="academic-year-2026-27" class="tab-pane fade active in">
          <p><!-- Undergraduate 2026-27 start --></p>
          <h3>新学生申请和入学费用</h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      申请及注册费用
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>
                      费用不可退款且不可转让。如需了解更多信息，
                      <a
                        href="https://www.scad.edu/about/contact"
                        target="_blank"
                        class="marking-links-processed"
                        data-region="content"
                        >请联系招生办公室</a
                      >。
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>网上申请费</td>
                  <td>$100</td>
                </tr>
                <tr>
                  <td>一次性报名费</td>
                  <td>$500</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>
            年度学费<a
              name="tuition"
              class="marking-links-processed"
              data-region="content"
              data-link-type="outgoing"
            ></a>
          </h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="3" style="background-color: #f5f5f5">
                    <h4>
                      本科生学费标准
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>基于每季度三门课程入学，为期三个季度</p>
                  </th>
                </tr>
                <tr>
                  <th>入学类别</th>
                  <th>学季学费</th>
                  <th>年度学费</th>
                </tr>
              </thead>
              <tbody>
                <!--                <tr>-->
                <!--                  <td>全日制本科学生</td>-->
                <!--                  <td>—</td>-->
                <!--                  <td>$42,975</td>-->
                <!--                </tr>-->
                <tr>
                  <td>
                    全日制本科学生，每季度三门课程
                    <p class="secondary-text">
                      <em>15 小时学分，150 小时教学</em>
                    </p>
                  </td>
                  <td>$14,325</td>
                  <td>$42,975</td>
                </tr>
                <tr>
                  <td>
                    全日制本科学生，每季度两门课程
                    <p class="secondary-text">
                      <em>10 小时学分，100 小时教学</em>
                    </p>
                  </td>
                  <td>$9,550</td>
                  <td>—</td>
                </tr>
                <tr>
                  <td>
                    兼职本科学生，每季度一门课程
                    <p class="secondary-text">
                      <em>5 小时学分，50 小时教学</em>
                    </p>
                  </td>
                  <td>$4,775</td>
                  <td>—</td>
                </tr>
                <tr>
                  <td>一学分</td>
                  <td>$955</td>
                  <td>—</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>住宿</h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      SCADhome 一学年住宿预定费
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>不可退款且不可转让</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    住宿申请费需在首个住宿季度开始前支付。更多信息请访问
                    <a
                      href="https://www.scad.edu/life/scadhome/housing-application-and-guidelines"
                      target="_blank"
                      >SCADhome 住宿申请</a
                    >。
                  </td>
                  <td>$750</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table
              class="
                table
                table-condensed
                table-outlined
                table-bordered
                table-striped
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="6" style="background-color: #f5f5f5">
                    <h4>
                      萨凡纳校区住宿
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>
                      年度费用包括住宿申请费，并涵盖秋季、冬季和春季三个学期（季度）。
                    </p>
                  </th>
                </tr>
                <tr>
                  <th>学生公寓</th>
                  <th>户型说明</th>
                  <th>入住人数</th>
                  <th>学季费用</th>
                  <th>年度费用</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/barnard-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Barnard Village</a
                    >
                  </td>
                  <td>四人公寓，四室一厅两卫，带厨房</td>
                  <td>4</td>
                  <td>$4,250</td>
                  <td>$13,500</td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/boundary-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Boundary Village</a
                    >
                  </td>
                  <td>四人公寓，四室一厅两卫，带厨房</td>
                  <td>4</td>
                  <td>$4,250</td>
                  <td>$13,500</td>
                </tr>
                <!-- Chatham (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/chatham"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Chatham</a
                    >
                  </td>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,917</td>
                  <td>$12,501</td>
                </tr>
                <tr>
                  <td>二人开间，带独立卫浴</td>
                  <td>2</td>
                  <td>$4,078</td>
                  <td>$12,984</td>
                </tr>
                <!-- FORTY EIGHT (4 rows) -->
                <tr>
                  <td rowspan="4">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty-eight"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY EIGHT</a
                    >
                  </td>
                  <td>四人套间，两室两卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,985</td>
                  <td>$12,705</td>
                </tr>
                <tr>
                  <td>二人开间，带独立卫浴</td>
                  <td>2</td>
                  <td>$4,650</td>
                  <td>$14,700</td>
                </tr>
                <tr>
                  <td>四人公寓，四室一厅两卫，带厨房</td>
                  <td>4</td>
                  <td>$4,650</td>
                  <td>$14,700</td>
                </tr>
                <tr>
                  <td>双人公寓，两室一厅一卫，带厨房</td>
                  <td>2</td>
                  <td>$5,485</td>
                  <td>$17,205</td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/colony-hive"
                      class="marking-links-processed"
                      data-region="content"
                      >The Hive</a
                    >
                  </td>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/montgomery-house"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Montgomery House</a
                    >
                  </td>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,634</td>
                  <td>$11,652</td>
                </tr>
                <!-- Oglethorpe House (2 rows) --><!--<tr>
				<td rowspan="2">
					<a href="/life/buildings-and-facilities/oglethorpe-house" target="_blank">Oglethorpe House</a></td>
				<td>
					1 double-occupancy studio room, 1 bath</td>
				<td>
					Shared</td>
				<td>
					2</td>
				<td>
					$3,323</td>
				<td>
					$10,719</td>
			</tr>
			<tr>
				<td>
					1 single-occupancy studio room, 1 bath</td>
				<td>
					Private</td>
				<td>
					1</td>
				<td>
					$3,767</td>
				<td>
					$12,051</td>
			</tr>--><!-- River (2 rows) -->
                <tr>
                  <td rowspan="2">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/river"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >River</a
                    >
                  </td>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>单人套间，一室一厅一卫</td>
                  <td>1</td>
                  <td>$4,417</td>
                  <td>$14,001</td>
                </tr>
                <!-- Sail and Surf at Victory Village (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/sail-victory-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Sail</a
                    >
                    and
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/surf-victory-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Surf</a
                    >
                    at Victory Village
                  </td>
                  <td>四人套间，两室两卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>二人套间，一室一卫，带共享客厅</td>
                  <td>2</td>
                  <td>$3,917</td>
                  <td>$12,501</td>
                </tr>
                <tr>
                  <td>单人开间，带独立卫浴</td>
                  <td>1</td>
                  <td>$4,417</td>
                  <td>$14,001</td>
                </tr>
                <!-- Sand at Victory Village (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/sand-victory-village"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Sand at Victory Village</a
                    >
                  </td>
                  <td>四人公寓，四室一厅两卫，带厨房</td>
                  <td>4</td>
                  <td>$4,417</td>
                  <td>$14,001</td>
                </tr>
                <tr>
                  <td>双人公寓，两室一厅一卫，带厨房</td>
                  <td>2</td>
                  <td>$5,212</td>
                  <td>$16,386</td>
                </tr>
                <tr>
                  <td>单人独立公寓，一室一厅一卫，带厨房</td>
                  <td>1</td>
                  <td>$6,033</td>
                  <td>$18,849</td>
                </tr>
                <!-- Turner House (2 rows) -->
                <tr>
                  <td rowspan="2">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/turner-house"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >Turner House</a
                    >
                  </td>
                  <td>三人开间，带独立卫浴</td>
                  <td>3</td>
                  <td>$3,105</td>
                  <td>$10,065</td>
                </tr>
                <tr>
                  <td>二人开间，带独立卫浴</td>
                  <td>2</td>
                  <td>$3,383</td>
                  <td>$10,899</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table
              class="
                table
                table-condensed
                table-outlined
                table-bordered
                table-striped
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="6" style="background-color: #f5f5f5">
                    <h4>
                      亚特兰大校区住宿
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>
                      年度费用包括住宿申请费，并涵盖秋季、冬季和春季三个学期（季度）。
                    </p>
                  </th>
                </tr>
                <tr>
                  <th>学生公寓</th>
                  <th>户型说明</th>
                  <th>入住人数</th>
                  <th>季度费用</th>
                  <th>年度费用</th>
                </tr>
              </thead>
              <tbody>
                <!-- FORTY (3 rows) -->
                <tr>
                  <td rowspan="3">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY</a
                    >
                  </td>
                  <td>八人套间，四室两卫，带共享客厅</td>
                  <td>8</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <tr>
                  <td>四人公寓，两室一厅一卫，带厨房</td>
                  <td>4</td>
                  <td>$4,420</td>
                  <td>$14,010</td>
                </tr>
                <!-- FORTY FOUR (4 rows) -->
                <tr>
                  <td rowspan="4">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty-four"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY FOUR</a
                    >
                  </td>
                  <td>二人开间，带独立卫浴</td>
                  <td>2</td>
                  <td>$3,667</td>
                  <td>$11,751</td>
                </tr>
                <tr>
                  <td>四人套间，两室两卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,917</td>
                  <td>$12,501</td>
                </tr>
                <tr>
                  <td>四人公寓，两室一厅两卫，带厨房</td>
                  <td>4</td>
                  <td>$4,417</td>
                  <td>$14,001</td>
                </tr>
                <tr>
                  <td>单人开间，带独立卫浴</td>
                  <td>1</td>
                  <td>$4,417</td>
                  <td>$14,001</td>
                </tr>
                <!-- FORTY FIVE (2 rows) -->
                <tr>
                  <td rowspan="2">
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/forty-five"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >FORTY FIVE</a
                    >
                  </td>
                  <td>二人开间，带独立卫浴</td>
                  <td>2</td>
                  <td>$3,667</td>
                  <td>$11,751</td>
                </tr>
                <tr>
                  <td>四人套间，两室一卫，带共享客厅</td>
                  <td>4</td>
                  <td>$3,783</td>
                  <td>$12,099</td>
                </tr>
                <!-- SCAD House -->
                <tr>
                  <td>
                    <a
                      href="https://www.scad.edu/life/buildings-and-facilities/scad-house"
                      target="_blank"
                      class="marking-links-processed"
                      data-region="content"
                      >SCAD House</a
                    >
                  </td>
                  <td>双人公寓，两室一厅一卫，带厨房</td>
                  <td>2</td>
                  <td>$4,064</td>
                  <td>$12,942</td>
                </tr>

                <!--                <tr data-v-56a4153b="">-->
                <!--                  <td data-v-56a4153b="" colspan="5" style="background: white">-->
                <!--                    <p data-v-56a4153b="" class="secondary-text">-->
                <!--                      <em data-v-56a4153b=""-->
                <!--                        >*费用包含住宿、家具、水电费及本地电话、有线电视和互联网服务。宿舍安排可能调整，具体信息将通知需强制住宿的学生。学校不保证特定住房分配。宿舍名额有限，自每年-->
                <!--                        7 月 1 日起按付款到账及合同签署顺序确认。</em-->
                <!--                      >-->
                <!--                    </p>-->
                <!--                  </td>-->
                <!--                </tr>-->
              </tbody>
            </table>
          </div>
          <!--<div class="table-responsive">
            <table class="table table-condensed table-outlined table-bordered margin-bottom-all-40">
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5;">
                    <h4>
                      Summer housing <span style="font-size: 13px; font-weight: 400;">2026-27 (Atlanta, Savannah)</span></h4>
                    <p>*Includes the summer housing application fee.</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    Summer housing application fee</td>
                  <td>
                    $250</td>
                </tr>
                <tr>
                  <td>
                    Double-occupancy suite</td>
                  <td>
                    $4,033*</td>
                </tr>
                <tr>
                  <td>
                    Apartment, double-occupancy</td>
                  <td>
                    $4,670*</td>
                </tr>
                <tr>
                  <td>
                    Apartment, private bedroom</td>
                  <td>
                    $4,500*</td>
                </tr>
              </tbody>
            </table>
          </div>-->
          <h3>餐饮</h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="3" style="background-color: #f5f5f5">
                    <h4>
                      膳食计划
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>
                      膳食计划年度费用涵盖秋季、冬季和春季学季三个学期，并默认所选膳食计划在此期间保持不变。膳食计划可在亚特兰大校区和萨凡纳校区的餐饮场所使用。
                      <a
                        href="https://www.scad.edu/life/dining/meal-plans"
                        target="_blank"
                        class="marking-links-processed"
                        data-region="content"
                        >了解更多膳食计划选项</a
                      >。
                    </p>
                  </th>
                </tr>
                <tr>
                  <th>膳食计划套餐</th>
                  <th>季度费用</th>
                  <th>年度费用</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>18 餐/周，$75 餐饮余额</td>
                  <td>$2,250</td>
                  <td>$6,750</td>
                </tr>
                <tr>
                  <td>14 餐/周，$150 餐饮余额</td>
                  <td>$2,225</td>
                  <td>$6,675</td>
                </tr>
                <tr>
                  <td>135 餐/学季，$125 餐饮余额</td>
                  <td>$2,115</td>
                  <td>$6,345</td>
                </tr>

                <tr>
                  <td>10 餐/周，$450 餐饮余额</td>
                  <td>$1,950</td>
                  <td>$5,850</td>
                </tr>

                <tr>
                  <td>学生公寓膳食计划｜50餐/学季，$450 餐饮余额</td>
                  <td>$1,200</td>
                  <td>$3,600</td>
                </tr>

                <tr>
                  <td>学生公寓膳食计划｜85 餐/学季，$75 餐饮余额</td>
                  <td>$1,175</td>
                  <td>$3,525</td>
                </tr>
                <tr>
                  <td>学生公寓膳食计划｜50 餐/学季，$100 餐饮余额</td>
                  <td>$800</td>
                  <td>$2,400</td>
                </tr>
                <tr>
                  <td>学生公寓膳食计划｜25 餐/学季，$125 餐饮余额</td>
                  <td>$510</td>
                  <td>$1,530</td>
                </tr>

                <tr>
                  <td>学生公寓膳食计划｜$550 餐饮余额</td>
                  <td>$525</td>
                  <td>$1575</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>国际学生健康保险</h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      学生健康服务年费
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>仅适用于 SCAD 萨凡纳校区的所有学生</p>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    HiveHealth 是为 SCAD
                    萨凡纳校区学生提供服务的医疗健康中心，学生使用该服务无需支付共付额（co-pay）或单次就诊费用。此项年费涵盖整个学年的不限次数就诊服务，并且部分服务可能产生额外费用。<a
                      href="https://www.scad.edu/life/health-and-wellness/student-health-services"
                      target="_blank"
                      >了解更多</a
                    >
                  </td>

                  <td class="c150pcclass">$125</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      Anthem Student Advantage 学生健康保险
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>仅适用于国际学生</p>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    SCAD 要求所有国际学生在整个学年期间保持有效的健康保险。持
                    F-1 签证 的学生将自动注册 Student Advantage
                    学生健康保险计划。符合特定条件的学生可能可以申请豁免。所列费用为规划参考的预计金额，实际费率将于2026
                    年 9 月 1
                    日（星期二）起生效，具体费用将根据学生的注册日期以及是否包含家属保险(dependent
                    coverage) 而有所不同。<a
                      href="https://www.scad.edu/life/international-student-life/prepare-life-scad/health-care-international-students"
                      target="_blank"
                      >了解更多</a
                    >
                  </td>

                  <td rowspan="2" style="border-bottom: 0" class="c150pcclass">
                    $1,417*
                  </td>
                </tr>
                <tr>
                  <td style="border-right: 1px solid #ddd">
                    <p class="secondary-text">
                      <em
                        >*该费用按2026年9月1日至2027年8月31日的保险覆盖期计算。提前抵达
                        SCAD
                        的学生可能需要支付延长保险覆盖期所产生的额外费用。</em
                      >
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>
            ESL（英语作为第二语言）课程及 SCAD Language Studio 语言课程学费
          </h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      10 周常规语言课程
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    一级、二级、三级和四级语言课程
                    <p class="secondary-text"><em>20 个 ESL 学时</em></p>
                  </td>
                  <td>$3,568</td>
                </tr>
                <tr>
                  <td>
                    五级语言课程
                    <p class="secondary-text"><em>15 个 ESL 学时*</em></p>
                  </td>
                  <td>$2,676</td>
                </tr>
                <tr>
                  <td>
                    六级语言课程 （本科生阶段）
                    <p class="secondary-text">
                      <em>10个 ESL 学时**</em>
                    </p>
                  </td>
                  <td>$1,784</td>
                </tr>
                <tr>
                  <td colspan="2">
                    <p class="secondary-text">
                      <em
                        >*仅包含 ESL
                        课程费用（学生还需选修一门专业课程，并另行支付该课程学费。）</em
                      >
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      英语作为第二语言 LEAP 课程 5 周在线课程
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    学术用途英语课程 <br />
                    <p class="secondary-text">
                      <em>为期 5 周线上课程，每周 5 小时 ESL 学习</em>
                    </p>
                  </td>
                  <td class="c150pcclass">$892</td>
                </tr>
              </tbody>
            </table>
          </div>
          <h3>SCAD Lacoste 法国拉科斯特海外学习项目</h3>
          <div class="table-responsive">
            <table
              class="
                table table-condensed table-outlined table-bordered
                margin-bottom-all-40
              "
            >
              <thead>
                <tr>
                  <th colspan="2" style="background-color: #f5f5f5">
                    <h4>
                      10 周 SCAD Lacoste 海外学习费用
                      <span style="font-size: 13px; font-weight: 400"
                        >2026-27</span
                      >
                    </h4>
                    <p>
                      了解更多关于<a
                        href="https://scad-sa.terradotta.com/_portal/tds-program-brochure?programid=10000"
                        target="_blank"
                        class="marking-links-processed"
                        data-region="content"
                        data-link-type="outgoing"
                        >法国拉科斯特海外学习项目</a
                      >的信息
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    SCAD Lacoste 海外学习项目押金
                    <p class="secondary-text">
                      <em>不可退款；将计入项目总费用</em>
                    </p>
                  </td>
                  <td>$850</td>
                </tr>
                <tr>
                  <td>拉科斯特校区学费</td>
                  <td>
                    <!--                    <a-->
                    <!--                      class="smooth-scroll marking-links-processed"-->
                    <!--                      href="https://www.scad.edu/admission/tuition-and-fees/undergraduate#tuition"-->
                    <!--                      data-region="content"-->
                    <!--                      >View tuition fees</a-->
                    <!--                    >-->

                    （学季学费费用详见上表）
                  </td>
                </tr>
                <tr>
                  <td>
                    项目费用（包括住宿、餐饮和实地参观费用）
                    <p class="secondary-text">
                      <em
                        >参与者需自行承担所有个人开销，包括在拉科斯特校区之外用餐的费用。</em
                      >
                    </p>
                  </td>
                  <td>$8,825</td>
                </tr>
                <tr>
                  <td>
                    保险费用
                    <p class="secondary-text">
                      <em
                        >所有参加海外学习项目的学生将自动加入 SCAD
                        学生保险计划。相关保险费用将按季度计入学生账单。请注意：该保险并非主要医疗保险，仅为海外学习期间的专项保险保障。留学保险有关该政策的更多信息，请发送电子邮件至
                        studyabroad@scad.edu。</em
                      >
                    </p>
                  </td>
                  <td>$75</td>
                </tr>
                <tr>
                  <td>行政管理费用</td>
                  <td>$50</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Undergraduate 2026-27 end -->
        </div>
      </div>
    </div>
    <goTop></goTop>
    <custFooter></custFooter>
  </div>
</template>

<script>
import menuBar from "../../../../components/menuBar/index.vue";
import custFooter from "@/components/footer/Footer";
export default {
  metaInfo: {
    title: "SCAD", // set a title
  },
  name: "TuitionandFees",
  components: {
    menuBar,
    custFooter,
  },
  data() {
    return {
      mealPlans: true,
    };
  },
  created() {
    if (this.$route.query.t === "preview") {
      this.mealPlans = true;
    }
  },
};
</script>

<style scoped lang="less">
@import "../TuitionandFees.less";
</style>
